<!-- 添加新电表选择设备弹窗 -->
<template>
	<dialogBody @confirm="confirm" @cancel="cancel" ref="body">
		<template slot="title">
			{{title}}
		</template>
		<div class="meterSet" style="min-height: 320px;">
			<div class="formContainer">
				<p><span class="required">*</span>登录密码</p>
				<input type="password" v-model.trim="verifyPassword" autocomplete="new-password" maxlength="100" placeholder="请输入登录密码" />
			</div>
			<div class="formContainer">
				<p><span class="required">*</span>缴费日期</p>
				<singleSelection class="singleSelection" :nameKey="'text'" :list="dateList" :autoCheck="autoCheck" @checkItem="selectDate($event)"></singleSelection>
			</div>
		</div>
	</dialogBody>
</template>

<script>
	import dialogBody from '@/components/module/dialog/dialogBody.vue'
	import singleSelection from '@/components/module/selection/singleSelection.vue'
	import meterManagerStore from '../meterManagerStore.js'
	export default {
		components: {
			dialogBody,
			singleSelection,
		},
		props: {
			
		},
		data() {
			return {
				title: '',
				callback: undefined,
				verifyPassword: '',
				deductionFeeDay: 1,
				autoCheck: 1
			}
		},
		computed: {
			dateList() {
				var list = []
				for(var i = 1;i < 32;i++){
					list.push({text:i+'日',value:i})
				}
				return list
			},
		},
		watch: {},
		mounted() {},
		methods: {
			selectDate(item) {
				this.deductionFeeDay = item.value
			},
			confirm() {
				if(this.verifyPassword == '' || this.verifyPassword == undefined){
					this.$dialogMethod.showMessage('必填项不可为空')
					return
				}
				if(this.callback != undefined){
					this.callback({password:hex_md5(this.verifyPassword), deductionFeeDay: this.deductionFeeDay})
				}
				this.close()
			},
			cancel() {
				this.close()
			},
			close() {
				this.verifyPassword = ''
				this.$refs.body.hide()
			},
			open(title, deductionFeeDay, callBack) {
				this.title = title
				this.deductionFeeDay = deductionFeeDay
				this.autoCheck = parseInt(deductionFeeDay) - 1
				this.callback = callBack
				this.$refs.body.open()
			},
			keydownInt(ev) {
				if(ev.keyCode == 109 || ev.keyCode == 229 || ev.keyCode == 110 || ev.keyCode == 190){
					ev.preventDefault()
				}
			},
		}
	}
</script>
<style scoped>
	.formContainer{
		margin-bottom: 10px;
	}
	
	.required{
		color: red;
	}
	
	.meterSet{
		padding: 10px;
	}
	
	.meterSet>label{
		display: block;
		line-height: 24px;
	}
	
	.meterSet>>>.selection>p{
		height: 32px;
		line-height: 32px;
	}
</style>